import Image from "next/image";
import styles from "./banner.module.css";

export default function Banner({ data }) {
  return (
    <div className={`${styles.bg} container-full`}>
      <Image
        src={data.imagem.url}
        alt="A Realiza"
        layout="fill"
        objectFit="cover"
        objectPosition="center"
      />
      <div className={`grid-cont align-self-center ${styles.content}`}>
        <div className={styles.title}>
          <div
            className={styles.parallelogramSpan}
            style={{ background: "#d72e3f" }}
          >
            <span>{data.titulo}</span>
          </div>
        </div>
        <h1>{data.chamada}</h1>
      </div>
    </div>
  );
}
